import React, { useRef, useEffect } from "react";
import { motion, useScroll, useTransform, useInView } from "motion/react";
import { useTitle } from "../utils/useTitle";

export const SectionWrapper = ({ children, className = "", title = "" }) => {
  const containerRef = useRef(null);
  const { setCurrentTitle } = useTitle();

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  // Track when section is more than 50% visible
  const isInView = useInView(containerRef, { amount: 0.5 });

  useEffect(() => {
    if (isInView && title) {
      setCurrentTitle(title);
    }
  }, [isInView, title, setCurrentTitle]);

  const scale = useTransform(
    scrollYProgress,
    [0, 0.2, 0.5, 0.7, 0.9, 1],
    [1.3, 1, 1, 0.75, 0.4, 0.2]
  );

  const opacity = useTransform(
    scrollYProgress,
    [0, 0.3, 0.5, 0.65, 0.8, 0.95, 1],
    [0, 1, 1, 0.7, 0.4, 0.1, 0]
  );
  const rounded = useTransform(
    scrollYProgress,
    [0, 0.2, 0.5, 0.7, 1],
    ["7rem", "4rem", "0rem", "4rem", "7rem"]
  );
  

  const y = useTransform(scrollYProgress, [0, 0.5, 1], [100, 0, -150]);

  return (
    <div
      ref={containerRef}
      className="relative h-screen w-screen"
      style={{
        zIndex: 10,
      }}
    >
      <div className="h-full w-full flex items-center justify-center overflow-hidden">
        <motion.div
          style={{
            scale,
            opacity,
            borderRadius: rounded,
            y,
            transform: "translateZ(0)",
            willChange: "transform, opacity",
          }}
          className={`w-full h-full flex flex-col items-center justify-center bg-shade-1 overflow-hidden shadow-2xl ${className}`}
        >
         
          <div className="w-full h-full flex items-center mt-20 justify-center">
            {children}
          </div>
        </motion.div>
      </div>
    </div>
  );
};
